import React from 'react';
import styled from 'styled-components';

const whenPropIsTrue = (propName, styles) => props => (props[propName] ? styles : '');

export const SelectItem = styled.li`
    padding: 15px 20px 15px 15px;
    cursor: pointer;

    ${whenPropIsTrue('highlighted', 'background-color: #dceaff')};
    ${whenPropIsTrue('selected', 'background-color: #bbd6ff')};
    ${whenPropIsTrue('static', 'cursor: default')};
`;

export const renderSelectItems = determineSelected => ({
    selectedItem,
    highlightedIndex,
    getItemProps
}) => (item, index) => (
    <SelectItem
        selected={determineSelected(item, selectedItem)}
        highlighted={index === highlightedIndex}
        {...getItemProps({
            key: item.value,
            index,
            item
        })}
    >
        {item.label}
    </SelectItem>
);
